import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { Container } from 'containers/common/LegalProceedings/ExpertReport/styled-component';
import { Listings } from 'containers/AppContainer/typings';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import { translate } from 'containers/services/translate';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  ExpertReportType,
  IExpertGlobalReportState,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import ExpertiseRecap from 'containers/common/LegalProceedings/ExpertReport/ExpertRecap';
import { showValidator } from 'containers/common/LegalProceedings/utils';
import { get } from 'lodash';
import ValidatorRecap from 'containers/common/LegalProceedings/ValidatorRecap';
import { COLORS } from 'constants/design';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import { Claim } from 'containers/PreOpeningPage/typings';
import { VictimType } from 'typings/globalTypes';

export interface ExpertReportProps {
  intl: IntlShape;
  expertReportState: IExpertGlobalReportState[];
  listings: Listings;
  uploadDocument?: Function;
  uploadedDocument?: IUploadedDocument;
  resetUploadedDocument?: Function;
  documentId?: string;
  setDocumentId?: Function;
  claimId: number;
  readOnly?: boolean;
  isManager?: boolean;
  expertReport: ExpertReportType;
  setIsDecisionDialgOpen?: Function;
  setExpertReportState: Function;
  isDecisionDialgOpen?: boolean;
  validateVictimExpertise?: any;
  isAssignedLawyer: boolean;
  isCreator?: boolean;
  deactivateButton?: any;
  setDeactivateButton?: Function;
  judgementAddDocuments?: any;
  setIsSuccessPopinOpen?: Function;
  victimExpertises?: any;
  vehicleExpertises?: any;
  requestCreateExpertiseRaport?: Function;
  requestValidateExpertReport?: Function;
  requestGetExpertiseRaport?: Function;
  claimNumber: string;
  judiciaryProcessId?: number;
  assignedLawyers?: string[];
  victims?: VictimType[];
  claim?: Claim;
  policyInfo?: any;
  hasJom?: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isBasicManagement?: boolean;
  imagineDocuments: any;
  dahirAmount?: any;
  expertiseRaportFirstInstance: any;
  requestGetDocByDocumentumId: Function;
}

export const ExpertReport: React.FC<ExpertReportProps> = (
  props,
): JSX.Element => {
  const hasValidator = showValidator(
    get(props, 'expertReport.validator', ''),
    props.isManager || false,
  );
  return (
    <Container id="expert-report-wrapper">
      {get(props.expertReport, 'rejectionReason', '') &&
        get(props.expertReport, 'status', '') ===
          PROCEDURE_STATUSES.REJECTED && (
          <span className="pronouncing-title" style={{ color: COLORS.RED }}>
            {translate(messages.rejectedTitle, props)}
            {` : ${get(props.expertReport, 'rejectionReason', '')}`}
          </span>
        )}
      {hasValidator &&
        get(props, 'expertReport.status', '') !==
          PROCEDURE_STATUSES.PENDING && (
          <ValidatorRecap
            validator={get(props, 'expertReport.validator', '')}
          />
        )}
      {props.expertReportState.map((document, documentIndex) => (
        <div key={document.id}>
          <div className="pronouncing-title">
            {translate(messages.judgement, props, {
              index: documentIndex + 1,
            })}
          </div>
          <ExpertiseRecap
            documentIndex={documentIndex}
            expertises={document.expertises}
            {...props}
            isRecap
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            isBasicManagement={props.isBasicManagement}
            documentId={props.documentId}
            setDocumentId={props.setDocumentId}
            imagineDocuments={props.imagineDocuments}
            dahirAmount={props.dahirAmount}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        </div>
      ))}
    </Container>
  );
};

export default injectIntl(ExpertReport);
